import React, { Fragment } from "react";
import { Card, CardText } from "@cdk-uip/react-card";
import { CircularProgress } from "@cdk-uip/react-circular-progress";
import { IconButton } from "@cdk-uip/react-icon-button";

const ROW_OPTIONS = [10, 20, 30, 50, 100];

export default function UserRoleManagementPagination({
  currentPage = 1,
  totalPages = 1,
  totalItems = 0,
  pageSize = 30,
  loading = false,
  onPageChange,
  onPageSizeChange,
}) {
  const pageStart = totalItems === 0 ? 0 : (currentPage - 1) * pageSize + 1;
  const pageEnd = Math.min(currentPage * pageSize, totalItems);

  return (
    <Card style={{ boxShadow: "none", padding: "4px 8px", background: "transparent" }}>
      <CardText style={{ padding: 0 }}>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            fontSize: "12px",
            gap: "8px",
            width: "100%",
            height: "32px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <span>Rows per page:</span>
            <select
              value={pageSize}
              onChange={(e) => onPageSizeChange(Number(e.target.value))}
              style={{
                fontSize: "12px",
                padding: "2px 6px",
                borderRadius: "4px",
                border: "1px solid #ccc",
              }}
            >
              {ROW_OPTIONS.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <IconButton
              disabled={currentPage <= 1 || loading}
              onClick={() => onPageChange(1)}
              style={{ padding: "4px" }}
            >
              first_page
            </IconButton>
            <IconButton
              disabled={currentPage <= 1 || loading}
              onClick={() => onPageChange(currentPage - 1)}
              style={{ padding: "4px" }}
            >
              chevron_left
            </IconButton>
            <IconButton
              disabled={currentPage >= totalPages || loading}
              onClick={() => onPageChange(currentPage + 1)}
              style={{ padding: "4px" }}
            >
              chevron_right
            </IconButton>
            <IconButton
              disabled={currentPage >= totalPages || loading}
              onClick={() => onPageChange(totalPages)}
              style={{ padding: "4px" }}
            >
              last_page
            </IconButton>
            <span style={{ marginLeft: "4px", display: "flex", alignItems: "center" }}>
              {loading ? (
                <CircularProgress size="16px" />
              ) : (
                <Fragment>
                  {pageStart} - {pageEnd} of {totalItems}
                </Fragment>
              )}
            </span>
          </div>
        </div>
      </CardText>
    </Card>
  );
}